import React, { useState, useEffect } from "react";
import {
  Button,
  Collapse,
  Row,
  Col,
  Tabs,
  Divider,
  message,
  Modal,
  Spin,
  Form,
  DatePicker,
  Table,
  Avatar,
} from "antd";
import IntlMessages from "../../../util/IntlMessages";
import ds from "../../../Services/DataServices";
import { useHistory } from "react-router-dom";
import { useDispatch, useStore, useSelector } from "react-redux";
import InfoToPrint from "../../../components/InfoToPrint";
import Skeleton from "react-loading-skeleton";
import SalesHistoryPic from "../../../assets/images/saleshistory.png";
import { RollbackOutlined } from "@ant-design/icons";
import moment from "moment";
import { userLogOut } from "../../../appRedux/actions/Auth";
import _ from "lodash";
import { parse } from "@babel/core";
import {
  loadSaleHistoryCustomerShow,
  loadSaleHistoryCustomerLoad,
} from "../../../appRedux/actions/Sell";
import { loadShowIssueCreditModal } from "../../../appRedux/actions/MainSale";
import { checkIssueStoreCredit } from "../../../appRedux/actions/GlobalMethods";
import { setgroups } from "process";
import IssueStoreCredit from "../../../components/IssueStoreCredit";
import { loadCustomerAddEditModalShow } from "../../../appRedux/actions/CommonData";
import { BEHAVIOUR_TYPE } from "../../../Services/DataServices";
import { formatDigits, notAllowMsgCheck } from "../../../appRedux/actions";
import AddEditCustomerModal from "../../../components/AddEditCustomerModal";

const Panel = Collapse.Panel;
const { TabPane } = Tabs;
const confirm = Modal.confirm;
const { RangePicker } = DatePicker;

const CustomerModal = (props) => {
  const { allowUpdate, getIsIssueStoreCredit, returnStoreCredit } = props;
  const id = props.id ? props.id : false;
  const currShort = props.currShort ? props.currShort : "";
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const store = useStore();

  const getReduxCustomerShow = useSelector(
    ({ Sell }) => Sell.saleHistoryCustomerShow
  );
  const getReduxCustomerLoad = useSelector(
    ({ Sell }) => Sell.saleHistoryCustomerLoad //for customer search
  );
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  );

  const [getIsSpinning, setIsSpinning] = useState(false);
  const [getCusName, setCusName] = useState("");
  const [getGroupName, setGroupName] = useState("");
  const [getLastShop, setLastShop] = useState("");
  const [getCusNote, setCusNote] = useState("");
  const [getCusLoyalty, setCusLoyalty] = useState("0.00");
  const [getCusAccount, setCusAccount] = useState("0.00");
  const [getCusStoreCredit, setCusStoreCredit] = useState("0.00");
  const [getCusID, setCusID] = useState("");
  const [getCusCode, setCusCode] = useState("");
  const [getGender, setGender] = useState("");
  const [getDOB, setDOB] = useState("");
  const [getContact, setContact] = useState("");
  const [getEmail, setEmail] = useState("");
  const [getWebsite, setWebsite] = useState("");
  const [getTwitter, setTwitter] = useState("");
  const [getPostalAddress, setPostalAddress] = useState("");
  const [getPhysicalAddress, setPhysicalAddress] = useState("");
  const [getStoreCreditData, setStoreCreditData] = useState([]);

  React.useEffect(() => {
    if (id) {
      setIsSpinning(true);
      getDataForEdit(id);
      getStoreCreditService({ CustomerID: id });
    } else {
      // message.error("Server is down, kindly retry later...");
      // setIsSpinning(false);
    }
  }, [id]);

  async function getDataForEdit(id) {
    const createReq = ds.getDataForCustomerEdit(
      { _CustomerSId: id },
      BEHAVIOUR_TYPE.GET
    );
    await createReq
      .then((data) => {
        setIsSpinning(false);
        if (data) {
          let date = "";
          let cusGender = "";
          if (data.lastShop) {
            date = new Date(data.lastShop);
            date = date.toLocaleString();
          }
          if (data.gender && data.gender != "") {
            cusGender =
              data.gender.toLowerCase() == "m"
                ? "Male"
                : data.gender.toLowerCase() == "f"
                ? "Female"
                : data.gender.toLowerCase() == "b"
                ? "Non Binary"
                : "";
          }
          setPostalAddress(
            `${data.postalAddress} ${data.postalAddress2} ${data.subRub1} ${data.postalCode} ${data.city} ${data.state} ${data.postalCountry}`
          );
          setPhysicalAddress(
            `${data.permanentPostalAddress} ${data.permanentPostalAddress2} ${data.permanentSubRub1} ${data.permanentPostalCode} ${data.permanentCity} ${data.permanentState} ${data.physicalCountry}`
          );
          setEmail(data.customerEmail ? data.customerEmail : "");
          setContact(data.contactNumber ? data.contactNumber : "");
          setDOB(data.dateOfBirth ? data.dateOfBirth : "");
          setTwitter(data.twitter ? data.twitter : "");
          setWebsite(data.website ? data.website : "");
          setGender(cusGender);
          setCusCode(data.customerCode ? data.customerCode : "");
          setCusName(`${data.customerFirstName} ${data.customerLastName}`);
          setGroupName(data.customerGroupName);
          setCusLoyalty(
            `${
              data.loyaltyValue
                ? formatDigits(data.loyaltyValue, getDecimalPlaces)
                : "0.00"
            }`
          );
          setCusAccount(
            `${
              data.accountCredit
                ? formatDigits(data.accountCredit, getDecimalPlaces)
                : "0.00"
            }`
          );
          setCusStoreCredit(
            `${
              data.storeCredit
                ? formatDigits(data.storeCredit, getDecimalPlaces)
                : "0.00"
            }`
          );
          setLastShop(date);
          setCusNote(data.note ? data.note : "");
        }
      })
      .catch((e) => {
        notAllowMsgCheck(e);
        setIsSpinning(false);
        setCusName("");
        setGroupName("");
        setCusLoyalty("");
        setCusAccount("");
        setCusStoreCredit("");
        setLastShop("");
        setCusNote("");
        setPostalAddress("");
        setPhysicalAddress("");
        setEmail("");
        setContact("");
        setDOB("");
        setTwitter("");
        setWebsite("");
        setGender("");
        setCusCode("");
        message.error("Some thing went wrong");
      });
  }

  async function getStoreCreditService(body) {
    setIsSpinning(true);
    const createReq = ds.getCusStoreCreditService(body, BEHAVIOUR_TYPE.GET);
    await createReq
      .then((data) => {
        setIsSpinning(false);
        if (data && data.length > 0) setStoreCreditData(data);
        else setStoreCreditData([]);
      })
      .catch((e) => {
        notAllowMsgCheck(e);
        setIsSpinning(false);
      });
  }

  function viewCustomerSales() {
    if (id) {
      // setIsSpinning(true);
      if (!window.location.pathname.toLowerCase().includes("salehistory")) {
        dispatch(loadSaleHistoryCustomerShow(false));
        history.push(`/dashboard/sell/salehistory/listing#cus${id}`);
      }
      dispatch(loadSaleHistoryCustomerLoad(!getReduxCustomerLoad));
    } else {
      message.error("Something's wrong, try again later...");
    }
  }

  function evenOrOdd(num) {
    //for string length take string
    if (num % 2 == 0) {
      //and replace numm with string.length here
      return "even";
    } else {
      return "odd";
    }
  }

  const columns = [
    {
      title: <IntlMessages id="products.promoadd.formdate" />,
      dataIndex: "date",
      key: "date",
      render: (text, record) => (
        <p className="custom-font-size-weight custom-font-color-black">
          {text ? moment(text).format("MMMM DD/YYYY h:mma") : ""}
        </p>
      ),
    },
    {
      title: <IntlMessages id="sell.cashlisting.col2" />,
      dataIndex: "user",
      key: "user",
      render: (text, record, key) => {
        let isEvenOrOdd = evenOrOdd(key);
        return (
          <>
            <div className="gx-module-list-icon">
              <Row gutter={12}>
                <Col>
                  <div className="gx">
                    <Avatar
                      style={{ fontWeight: "bold" }}
                      className={`gx-avatar gx-bg-${
                        isEvenOrOdd == "even" ? "green" : "blue"
                      } gx-size-46 mr-10`}
                    >
                      {record.lettersName}
                    </Avatar>
                  </div>
                </Col>

                <Col>
                  <div className="gx-module-list-content">
                    <div className="gx-mail-user-des">
                      <span className="gx-sender-name">{record.userName}</span>

                      <span className="gx-toolbar-separator">&nbsp;</span>

                      {/* <span className="vd-flag sm:hidden">{record.role}</span> */}
                    </div>
                    <div className="gx-message">
                      <p className="gx-text-truncate"> {record.userEmail}</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </>
        );
      },
    },
    {
      title: <IntlMessages id="setup.salesTax.mainOutlet.col2" />,
      dataIndex: "status",
      key: "status",
    },
    {
      title: <IntlMessages id="sell.sell.notes" />,
      dataIndex: "note",
      key: "note",
    },
    {
      title: <IntlMessages id="products.promoadd.amount" />,
      dataIndex: "amount",
      key: "amount",
    },
  ];

  return (
    <>
      <Modal className="AddUserModal"
        title={
          <div>
           
              <strong>{getCusName}</strong>
            <br></br>
           
              <p className="mb-0">
                {getGroupName}
                {getLastShop != "" ? (
                  <>
                    {" . "}
                    <IntlMessages id="customergmodal.lastshop" />
                    {` ${getLastShop}`}
                  </>
                ) : (
                  ""
                )}
              </p>
          </div>
        }
        centered
        footer={null}
        visible={getReduxCustomerShow}
        width={1000}
        onCancel={() => dispatch(loadSaleHistoryCustomerShow(false))}
      >
        <div className="user-modal">
          {id ? (
            <Spin
              tip={<IntlMessages id="sell.cashlisting.cashloading" />}
              spinning={getIsSpinning}
              size="large"
            >
              <Row justify="center">
                <Col className="mt-4 mb-5" style={{ textAlign: "center" }} span={8}>
                  <h3 className="mb-2">
                    <IntlMessages id="sell.salehistory.accountblnc" />
                  </h3>
                  <p className="mb-0">{`${currShort} ${getCusAccount}`}</p>
                </Col>
                <Col className="mt-4 mb-5" style={{ textAlign: "center" }} span={8}>
                  <h3 className="mb-2">
                    <IntlMessages id="sell.salehistory.loyalty" />
                  </h3>
                  <p className="mb-0">{`${currShort} ${getCusLoyalty}`}</p>
                </Col>
                <Col className="mt-4 mb-5" style={{ textAlign: "center" }} span={8}>
                <h3 className="mb-2">
                    <IntlMessages id="sell.salehistory.storeceredit" />
                  </h3>
                  <p className="mb-0">{`${currShort} ${getCusStoreCredit}`}</p>
                </Col>
              </Row>

              <Tabs defaultActiveKey="1" size="large">
                <TabPane
                  tab={<IntlMessages id="sell.salehistory.editcustab1" />}
                  key="1"
                >
                  {false ? (
                    <Skeleton count={5} height={30} />
                  ) : (
                    <div>
                      <h3>
                        <IntlMessages id="sell.salehistory.cusinfo" />
                      </h3>
                      <Divider />

                      {getCusCode != "" && (
                        <Row>
                          <Col span={8}>
                            <strong style={{ color: "#6692b0" }}>
                              <IntlMessages id="customerz.search.code" />
                            </strong>
                          </Col>
                          <Col span={16}>{getCusCode}</Col>
                        </Row>
                      )}

                      {getGender != "" && (
                        <Row>
                          <Col span={8}>
                            <strong style={{ color: "#6692b0" }}>
                              <IntlMessages id="customer.addCustomer.gender" />
                            </strong>
                          </Col>
                          <Col span={16}>{getGender}</Col>
                        </Row>
                      )}

                      {getDOB != "" && (
                        <Row>
                          <Col span={8}>
                            <strong style={{ color: "#6692b0" }}>
                              <IntlMessages id="customer.addCustomer.dob" />
                            </strong>
                          </Col>
                          <Col span={16}>
                            {moment(getDOB).format("YYYY-MM-DD")}
                          </Col>
                        </Row>
                      )}

                      {getCusCode == "" && getDOB == "" && getGender == "" && (
                        <strong style={{ color: "#6692b0" }}>
                          <IntlMessages id="sell.salehistory.cus.provcusinfo" />
                        </strong>
                      )}

                      <h3 style={{ marginTop: 28 }}>
                        <IntlMessages id="sell.salehistory.cus.contactinfo" />
                      </h3>
                      <Divider />

                      {getContact == "" &&
                        getEmail == "" &&
                        getWebsite == "" &&
                        getTwitter == "" &&
                        getPhysicalAddress == "" &&
                        getPostalAddress == "" && (
                          <strong style={{ color: "#6692b0" }}>
                            <IntlMessages id="sell.salehistory.cus.provcontinfo" />
                          </strong>
                        )}

                      {getContact != "" && (
                        <Row>
                          <Col span={8}>
                            <strong style={{ color: "#6692b0" }}>
                              <IntlMessages id="customer.addCustomer.contactNumber" />
                            </strong>
                          </Col>
                          <Col span={16}>{getContact}</Col>
                        </Row>
                      )}

                      {getEmail != "" && (
                        <Row>
                          <Col span={8}>
                            <strong style={{ color: "#6692b0" }}>
                              <IntlMessages id="customer.addCustomer.email" />
                            </strong>
                          </Col>
                          <Col span={16}>{getEmail}</Col>
                        </Row>
                      )}

                      {getWebsite != "" && (
                        <Row>
                          <Col span={8}>
                            <strong style={{ color: "#6692b0" }}>
                              <IntlMessages id="customer.addCustomer.website" />
                            </strong>
                          </Col>
                          <Col span={16}>{getWebsite}</Col>
                        </Row>
                      )}

                      {getTwitter != "" && (
                        <Row>
                          <Col span={8}>
                            <strong style={{ color: "#6692b0" }}>
                              <IntlMessages id="customer.addCustomer.twitter" />
                            </strong>
                          </Col>
                          <Col span={16}>{getTwitter}</Col>
                        </Row>
                      )}

                      {getPostalAddress != "" && (
                        <Row>
                          <Col span={8}>
                            <strong style={{ color: "#6692b0" }}>
                              <IntlMessages id="customer.addCustomer.postalAddressLabel" />
                            </strong>
                          </Col>
                          <Col span={16}>{getPostalAddress}</Col>
                        </Row>
                      )}

                      {getPhysicalAddress != "" && (
                        <Row>
                          <Col span={8}>
                            <strong style={{ color: "#6692b0" }}>
                              <IntlMessages id="customer.addCustomer.pyhsicalAddressLabel" />
                            </strong>
                          </Col>
                          <Col span={16}>{getPhysicalAddress}</Col>
                        </Row>
                      )}
                    </div>
                  )}
                  <Row gutter={10} justify="end">
                    <Col>
                      <Button className="custom-cusmodal-btns" type="primary" onClick={() => viewCustomerSales()} size="large" >
                        <IntlMessages id="sell.salehistory.reditocussale" />
                      </Button>
                    </Col>
                    <Col>
                      <Button className="custom-cusmodal-btns" type="primary" onClick={() => { let randomNbr = Math.floor( Math.random() * (999 - 100 + 1) + 100 );
                          let idCuss = id + randomNbr.toString();
                          setCusID(idCuss);
                          dispatch(loadCustomerAddEditModalShow(true));
                          dispatch(loadSaleHistoryCustomerShow(false));
                        }}
                        size="large"
                      >
                        <IntlMessages id="sell.salehistory.editcus" />
                      </Button>
                    </Col>
                  </Row>
                </TabPane>

                <TabPane
                  style={{ fontWeight: "bold" }}
                  tab={<IntlMessages id="sell.salehistory.editcustab2" />}
                  key="2"
                >
                  {false ? (
                    <Skeleton count={5} height={30} />
                  ) : getStoreCreditData && getStoreCreditData.length > 0 ? (
                    <Table
                      className="gx-table-responsive"
                      columns={columns}
                      dataSource={getStoreCreditData}
                    />
                  ) : (
                    <h3 style={{ color: "#6692b0" }}>
                      <IntlMessages id="sell.salehistory.nostorecredit" />
                    </h3>
                  )}
                  {getIsIssueStoreCredit && (
                    <Row>
                      <Col lg={24} md={24} sm={24} xs={24} className="text-right">

                        <Button
                          type="primary"
                          className=""
                          onClick={() => {
                            let randomNbr = Math.floor(
                              Math.random() * (999 - 100 + 1) + 100
                            );
                            let idCuss = id + randomNbr.toString();
                            setCusID(idCuss);
                            dispatch(loadShowIssueCreditModal(true));
                          }}
                        >
                          <IntlMessages id="mainsale.sell.issuestorecred" />
                        </Button>
                      </Col>
                    </Row>
                  )}
                </TabPane>

                <TabPane
                  style={{ fontWeight: "bold" }}
                  tab={<IntlMessages id="sell.salehistory.editcustab3" />}
                  key="3"
                >
                  {false ? (
                    <Skeleton count={5} height={30} />
                  ) : (
                    <h3 style={{ color: "#6692b0" }}>
                      {getCusNote && getCusNote != "" ? (
                        getCusNote
                      ) : (
                        <IntlMessages id="sell.salehistory.nocusnotes" />
                      )}
                    </h3>
                  )}
                </TabPane>
              </Tabs>
            </Spin>
          ) : (
            <h3>{"Server is down, please try again later"}</h3>
          )}
        </div>
      </Modal>
      <AddEditCustomerModal id={getCusID} />
      <IssueStoreCredit
        id={getCusID}
        allow={getIsIssueStoreCredit}
        curr={currShort}
        name={getCusName}
        returnStoreCredit={returnStoreCredit}
      />
    </>
  );
};

export default CustomerModal;
